<template>
  <div class="viewProgressionEmailComponent">
    <div class="container-fluid padding-bottom-2Perc">
      <div class="row margin-top-3Perc vertical-align"><!-- first row start -->
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
          <b>Group</b>
        </div>
        <div class="col-sm-4 col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
              <select class="form-control" v-model="selectedGroupObj">
                <option value=-1 disabled>Select</option>
                <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
          <b>Status</b>
        </div>
        <div class="col-sm-4 col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
              <select class="form-control" v-model="selectedCohortObj">
                <option value='-1' disabled>Select</option>
                <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
              </select> 
            </div>
          </div>
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
      </div>
      <div class="row margin-top-3Perc vertical-align">
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Sender</b></div> 
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
              <select class="form-control" v-model="selectedEmailObj">
                <option value='-1' disabled>Select</option>
                <option v-for="emailObj in getEmailList" v-bind:key="emailObj" v-bind:value="emailObj">{{ emailObj }}</option>
              </select> 
            </div>
          </div>  
        </div>
        <div class="col-sm-1 col-md-1 col-lg-1 text-align-right margin-top-0Point5Perc Padding-right-0px"><b>Template</b>
        </div>
        <div class="col-sm-4 col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
              <select class="form-control" v-model="selectedTemplateObj" @change="emailTemplateSelected">
                <option value='-1' disabled>Select</option>
                <option v-for="templateObj in getTemplateList" v-bind:key="templateObj.EmailTemplateId" v-bind:value="templateObj">{{ templateObj.EmailTemplateName }}</option>
              </select> 
            </div>
          </div>       
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
      </div>
      </div>
      <div class="row margin-top-3Perc">
        <button type="button" class="btn btn-default button-orange" @click="sendGroupEmails">View</button>
      </div>
      <view-progression-email-user-list></view-progression-email-user-list> 
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div> 
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTemplateString" v-bind:postfixString="postDeleteTemplateString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedTemplate"></confirmation-alert>
      <add-template-overlay v-if="ShowAddTemplateOverlay" @closeOverlay="closeTemplateOverlay"></add-template-overlay>
      <update-template-overlay v-bind:selectedTemplateObj="selectedTemplateObj" v-if="ShowUpdateTemplateOverlay" @closeOverlay="closeTemplateOverlay" @isUpdatedTemplate="isUpdateSelectedTemplate"></update-template-overlay>       
    </div>
  </template>
<script>
import AddTemplateOverlay from '@/components/emails/template/AddTemplateOverlay'
import UpdateTemplateOverlay from '@/components/emails/template/UpdateTemplateOverlay'
import ViewEmailUserList from '@/components/emails/email_users/ViewEmailUserList'
import ViewProgressionEmailUserList from '@/components/emails/progression_emails/ViewProgressionEmailUserList'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { VueEditor } from 'vue2-quill-editor'
import { groupCourseService } from '@/server-util/group-course-service'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { emailService } from '@/server-util/email-service'
import { participantService } from '@/server-util/participant-service'
import { templateService } from '@/server-util/template-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import lodash from 'lodash'
import Loader from '@/components/dashboard/Loader'
import tinymce from 'vue-tinymce-editor'
export default {
  created: function () {
    this.getAllGroupCourses()
    this.getSenderEmailIdList()
    this.getAllTemplateList()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      prefixDeleteTemplateString: 'Are you sure you want to delete ',
      postDeleteTemplateString: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      selectedEmailObj: -1,
      selectedTemplateObj: -1,
      associatedCohortList: [],
      UserObjList: [],
      checkedEnrolledUserId: [],
      checkedUnEnrolledUserId: [],
      showNoUserTxtInEnrolledUserBox: true,
      showNoUserTxtInUnEnrolledUserBox: true,
      totalEnrolledUserCount: 0,
      totalUnEnrolledUserCount: 0,
      templateContentValue: '',
      isSelectedAllUnEnrolledUser: false,
      isSelectedAllEnrolledUser: false,
      onlyMeCheckBox: true,
      supportCheckBox: false,
      customToolbar: [],
      selectedUserObj: null,
      ShowAddTemplateOverlay: false,
      ShowUpdateTemplateOverlay: false,
      closeOverlay: true,
      isEmailSentSuccessfully: false,
      progressBucketList: [],
      selectedProgressBucketObj: '-1',
      selectedEnrolledUserIdArr: [],
      selectedUnEnrolledUserIdArr: []
    }
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'view-email-user-list': ViewEmailUserList,
    'add-template-overlay': AddTemplateOverlay,
    'update-template-overlay': UpdateTemplateOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'view-progression-email-user-list': ViewProgressionEmailUserList,
    'loader': Loader,
    'tinymce': tinymce
  },
  methods: {
    updateUnEnrollExplicitSelectionFlag: function () {
      if (!this.isSelectedAllUnEnrolledUser) {
        this.selectedUnEnrolledUserIdArr = []
      } else {
        this.selectedUnEnrolledUserIdArr = []
        for (var i = 0; i < this.getUserList.length; i++) {
          var isUnEnrolled = this.getUserList[i].Unenrolled
          var minValue = parseInt(this.selectedProgressBucketObj.MinValue)
          var maxValue = parseInt(this.selectedProgressBucketObj.MaxValue)
          var userProgress = parseInt(this.getUserList[i].UserProgress)
          if (isUnEnrolled) {
            if (this.selectedProgressBucketObj !== '-1') {
              if (userProgress >= minValue && userProgress <= maxValue) {
                this.selectedUnEnrolledUserIdArr.push(this.getUserList[i].UserId)
              }
            } else {
              this.selectedUnEnrolledUserIdArr.push(this.getUserList[i].UserId)
            }
          }
        }
      }
    },
    updateEnrollExplicitSelectionFlag: function () {
      if (!this.isSelectedAllEnrolledUser) {
        this.selectedEnrolledUserIdArr = []
      } else {
        this.selectedEnrolledUserIdArr = []
        for (var i = 0; i < this.getUserList.length; i++) {
          var isUnEnrolled = this.getUserList[i].Unenrolled
          var minValue = parseInt(this.selectedProgressBucketObj.MinValue)
          var maxValue = parseInt(this.selectedProgressBucketObj.MaxValue)
          var userProgress = parseInt(this.getUserList[i].UserProgress)
          if (!isUnEnrolled) {
            if (this.selectedProgressBucketObj !== '-1') {
              if (userProgress >= minValue && userProgress <= maxValue) {
                this.selectedEnrolledUserIdArr.push(this.getUserList[i].UserId)
              }
            } else {
              this.selectedEnrolledUserIdArr.push(this.getUserList[i].UserId)
            }
          }
        }
      }
    },
    isUpdateSelectedTemplate (value) {
      // AK: Used to reset template filter to -1 if user updated any Template
      if (value) {
        this.selectedTemplateObj = -1
        this.templateContentValue = ''
      }
    },
    showDeleteConfirmation: function (event) {
      if (this.selectedTemplateObj !== -1) {
        this.showConfirmationBox = true
        this.postDeleteTemplateString = '\'' + this.selectedTemplateObj.EmailTemplateName + '\' template?'
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
      }
    },
    deleteSelectedTemplate (value) {
      this.showConfirmationBox = false
      // AK: Used to delete selected Template
      if (value) {
        this.deleteTemplate()
      }
    },
    deleteTemplate: function () {
      var storeObj = this.$store
      if (this.selectedTemplateObj !== -1) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        templateService
          .deleteTemplate(
            storeObj.state.access_token, this.selectedTemplateObj.EmailTemplateId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.selectedTemplateObj = -1
              // AK: After successfully delete, get all Template list again from server
              this.resetAllFields()
              this.getAllTemplateList()
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            // this.showSpinner = false
            this.$store.state.isLoading = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('TEMPLATE OBJECT IS NULL HENCE DECLINED DELETE TEMPALTE OPERATION.')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      // AK: If user recieved success msg on sent email then only reset values (DM-2343)
      if (this.isEmailSentSuccessfully) {
        this.isEmailSentSuccessfully = false
        this.resetAllFields()
      }
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getSenderEmailIdList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        emailService
          .getSenderEmailList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.senderEmailList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined SENDER EMAIL ID LISTING OPERATION'
        )
      }
    },
    getAllTemplateList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        emailService
          .getTemplateList(
            storeObj.state.access_token, constants.EmailTemplateType.Normal
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.templateList = responseObj.data
              // this.showSpinner = false
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined ALL TEMPLATE LISTING OPERATION'
        )
      }
    },
    emailTemplateSelected: function () {
      console.log('emailTemplateSelected', this.selectedTemplateObj)

      var store = this.$store
      var token = store.state.access_token
      emailService.getTemplateText(token, this.selectedTemplateObj.EmailTemplateId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // this.showSpinner = false
          this.$store.state.isLoading = false
          this.templateContentValue = responseObj.data.EmailTemplateText
          this.selectedTemplateObj.EmailTemplateText = responseObj.data.EmailTemplateText

          const index = lodash.findIndex(store.state.templateList, {EmailTemplateId: this.selectedTemplateObj.EmailTemplateId})
          if (index) {
            store.state.templateList[index].EmailTemplateText = responseObj.data.EmailTemplateText
          }
        }
      }, errorObj => {
        // this.showSpinner = false
        this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getParticipantListUsingCohort: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCohortObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .getParticipantListUsingCohortId(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Participant list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showNoUserTxtInEnrolledUserBox = true
                this.showNoUserTxtInUnEnrolledUserBox = true
                this.totalEnrolledUserCount = 0
                this.totalUnEnrolledUserCount = 0
                this.showAlertDialog = true
                this.errorMsg = 'No participant found in \'' + this.selectedCohortObj.CohortName + '\'.'
              } else {
                this.UserObjList = responseObj.data
                // this.checkAndAssignFlags()
                // console.log('this.UserObjList >>>' + JSON.stringify(this.UserObjList))
                this.updateFlagState()
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Cohort ID is NULL hence declined LISTING Associated Participant(s) OPERATION'
        )
      }
    },
    getProgressBucketFromServer: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        _this.$store.state.isLoading = true
        groupService
          .getProgressBuckets(
            storeObj.state.access_token,
            _this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Progress bucket response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.progressBucketList = responseObj.data
              // console.log(' buckets >>> ' + JSON.stringify(_this.progressBucketList))
              // if (responseObj.data.length === 0) {
              //   this.showNoUserTxtInEnrolledUserBox = true
              //   this.showNoUserTxtInUnEnrolledUserBox = true
              //   this.totalEnrolledUserCount = 0
              //   this.totalUnEnrolledUserCount = 0
              //   this.showAlertDialog = true
              //   this.errorMsg = 'No participant found in \'' + this.selectedCohortObj.CohortName + '\'.'
              // } else {
              //   this.UserObjList = responseObj.data
              //   this.checkAndAssignFlags()
              //   // console.log('this.UserObjList >>>' + JSON.stringify(this.UserObjList))
              // }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'GROUP ID is NULL hence declined LISTING Bucket List(s) OPERATION'
        )
      }
    },
    checkAndAssignFlags: function () {
      this.showNoUserTxtInEnrolledUserBox = true
      this.showNoUserTxtInUnEnrolledUserBox = true
      this.totalEnrolledUserCount = 0
      this.totalUnEnrolledUserCount = 0
      for (var i = 0; i < this.getUserList.length; i++) {
        if (this.getUserList[i].Unenrolled) {
          this.showNoUserTxtInUnEnrolledUserBox = false
          this.totalUnEnrolledUserCount += 1
        }
      }
      for (i = 0; i < this.getUserList.length; i++) {
        if (!this.getUserList[i].Unenrolled) {
          this.showNoUserTxtInEnrolledUserBox = false
          this.totalEnrolledUserCount += 1
        }
      }
    },
    checkRequiredFiledsBeforeSubmit: function () {
      if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.selectedCohortObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a cohort.'
        return false
      } else if (this.getUserIdListToSend().trim().length === 0 && this.getSupportCheckBoxValue === false && this.getOnlyMeCheckBoxValue === false) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select at least one participant.'
        return false
      } else if (this.selectedEmailObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a sender.'
        return false
      } else if (this.selectedTemplateObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return false
      } else if (this.stripHtml(this.templateContentValue).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Content can\'t be empty.'
        this.templateContentValue = this.selectedTemplateObj.EmailTemplateText
        return false
      }
      return true
    },
    sendGroupEmails: function () {
      var storeObj = this.$store
      if (this.checkRequiredFiledsBeforeSubmit()) {
        if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          var file1 = document.getElementById('file1').files[0]
          var file2 = document.getElementById('file2').files[0]
          var file3 = document.getElementById('file3').files[0]
          var file4 = document.getElementById('file4').files[0]
          var file5 = document.getElementById('file5').files[0]
          var file6 = document.getElementById('file6').files[0]

          const formData = new FormData()
          formData.append('groupCourseMasterId', this.selectedGroupObj.GroupCourseMasterId)
          formData.append('courseId', this.selectedCohortObj.CohortId)
          formData.append('emailSubject', this.selectedTemplateObj.EmailSubject)
          formData.append('senderEmail', this.selectedEmailObj)
          formData.append('templateName', this.selectedTemplateObj.EmailTemplateName)
          formData.append('templateText', this.templateContentValue)
          formData.append('toUsers', this.getUserIdListToSend())
          if (this.getOnlyMeCheckBoxValue === false && this.getSupportCheckBoxValue === false) {
            formData.append('testEmail', '')
            // console.log('testEmail Empty')
          } else if ((this.getOnlyMeCheckBoxValue === 'onlyme' || this.getOnlyMeCheckBoxValue === true) && this.getSupportCheckBoxValue === false) {
            formData.append('testEmail', 'onlyme')
            // console.log('testEmail', 'onlyme')
          } else if (this.getOnlyMeCheckBoxValue === false && (this.getSupportCheckBoxValue === 'support' || this.getSupportCheckBoxValue === true)) {
            formData.append('testEmail', 'support')
            // console.log('testEmail', 'support')
          }
          if (file1 !== undefined) {
            formData.append('file1', file1)
          }
          if (file2 !== undefined) {
            formData.append('file2', file2)
          }
          if (file3 !== undefined) {
            formData.append('file3', file3)
          }
          if (file4 !== undefined) {
            formData.append('file4', file4)
          }
          if (file5 !== undefined) {
            formData.append('file5', file5)
          }
          if (file6 !== undefined) {
            formData.append('file6', file6)
          }
          emailService
            .SendGroupMail(
              storeObj.state.access_token, formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Store it
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Total emails sent: ' + responseObj.data.TotalEmailsSent
                this.isEmailSentSuccessfully = true
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined SEND EMAIL OPERATION'
          )
        }
      }
    },
    getUserIdListToSend: function () {
      // AK: Used to get UserId's to send emails from both Enroll and Un-enroll list
      var userIdArr = []
      for (var i = 0; i < this.selectedEnrolledUserIdArr.length; i++) {
        userIdArr.push(this.selectedEnrolledUserIdArr[i])
      }
      for (i = 0; i < this.selectedUnEnrolledUserIdArr.length; i++) {
        userIdArr.push(this.selectedUnEnrolledUserIdArr[i])
      }
      console.log('getUserIdListToSend >>> ' + userIdArr + ' Length >>>> ' + userIdArr.length)
      return userIdArr.join(',')
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    resetAllFields: function () {
      // AK: After successfully sent mail to selected user, clear all filters
      this.selectedGroupObj = -1
      this.selectedCohortObj = -1
      this.selectedEmailObj = -1
      this.selectedTemplateObj = -1
      this.associatedCohortList = []
      this.UserObjList = []
      this.checkedEnrolledUserId = []
      this.checkedUnEnrolledUserId = []
      this.showNoUserTxtInEnrolledUserBox = true
      this.showNoUserTxtInUnEnrolledUserBox = true
      this.selectedProgressBucketObj = '-1'
      this.progressBucketList = []
      this.totalEnrolledUserCount = 0
      this.totalUnEnrolledUserCount = 0
      this.templateContentValue = ''
      this.isSelectedAllUnEnrolledUser = false
      this.isSelectedAllEnrolledUser = false
      this.selectedEnrolledUserIdArr = []
      this.selectedUnEnrolledUserIdArr = []
      this.onlyMeCheckBox = true
      this.supportCheckBox = false
      document.getElementById('file1').value = ''
      document.getElementById('file2').value = ''
      document.getElementById('file3').value = ''
      document.getElementById('file4').value = ''
      document.getElementById('file5').value = ''
      document.getElementById('file6').value = ''
    },
    openAddTemplateBox: function (event, flagToUpdate) {
      // AK: open participant details overlay
      this.ShowAddTemplateOverlay = flagToUpdate
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    closeTemplateOverlay (value) {
      // AK: used to hide the Add or Edit Template overlay after clicking on done or X
      this.ShowAddTemplateOverlay = value
      this.ShowUpdateTemplateOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
      if (this.selectedTemplateObj !== -1) {
        this.emailTemplateSelected()
      }
    },
    openUpdateTemplateOverlay: function (event, flagToUpdate) {
      if (this.selectedTemplateObj !== -1) {
        // AK: open Update Template overlay
        this.ShowUpdateTemplateOverlay = flagToUpdate
        // AK: Disable background scrolling
        this.$store.state.isOverlayVisible = flagToUpdate
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
      }
    },
    updateFlagState: function () {
      var enrolledUserCount = 0
      var unEnrolledUserCount = 0
      for (var i = 0; i < this.getUserList.length; i++) {
        var isUnEnrolled = this.getUserList[i].Unenrolled
        var minValue = parseInt(this.selectedProgressBucketObj.MinValue)
        var maxValue = parseInt(this.selectedProgressBucketObj.MaxValue)
        var userProgress = parseInt(this.getUserList[i].UserProgress)
        if (!isUnEnrolled) {
          // AK: Check for enrolled users
          if (this.selectedProgressBucketObj !== '-1') {
            // console.log('userProgress >>> ' + userProgress)
            // console.log('minValue >>> ' + minValue)
            // console.log('maxValue >>> ' + maxValue)
            if (userProgress >= minValue && maxValue >= userProgress) {
              // console.log('**If If***' + JSON.stringify(this.getUserList[i]))
              enrolledUserCount += 1
            }
          } else {
            // console.log('**else***')
            enrolledUserCount += 1
          }
        } else {
          // AK: Check for Un-enrolled users
          if (this.selectedProgressBucketObj !== '-1') {
            // console.log('userProgress >>> ' + userProgress)
            // console.log('minValue >>> ' + minValue)
            // console.log('maxValue >>> ' + maxValue)
            if (userProgress >= minValue && maxValue >= userProgress) {
              // console.log('**If If***' + JSON.stringify(this.getUserList[i]))
              unEnrolledUserCount += 1
            }
          } else {
            // console.log('**else***')
            unEnrolledUserCount += 1
          }
        }
      }

      if (enrolledUserCount > 0) {
        this.showNoUserTxtInEnrolledUserBox = false
      } else {
        this.showNoUserTxtInEnrolledUserBox = true
      }

      if (unEnrolledUserCount > 0) {
        this.showNoUserTxtInUnEnrolledUserBox = false
      } else {
        this.showNoUserTxtInUnEnrolledUserBox = true
      }
    }
  },
  computed: {
    selectedProgressBucketObjValue: {
      get: function () {
        return this.selectedProgressBucketObj
      },
      set: function (newValue) {
        this.selectedEnrolledUserIdArr = []
        this.isSelectedAllEnrolledUser = false
        this.selectedUnEnrolledUserIdArr = []
        this.isSelectedAllUnEnrolledUser = false
        this.selectedProgressBucketObj = newValue

        this.updateFlagState()
      }
    },
    getProgressBucketList: {
      get: function () {
        return this.progressBucketList
      }
    },
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getEmailList: {
      get: function () {
        return this.$store.state.senderEmailList
      }
    },
    getTemplateList: {
      get: function () {
        return this.$store.state.templateList
      }
    },
    getUserList: {
      get: function () {
        // this.checkAndAssignFlags()
        console.log('this.UserObjList >>> ' + JSON.stringify(this.UserObjList))
        return this.UserObjList.filter(function (item) {
          return parseInt(item.AccountType) < parseInt(constants.UserAccountType.Coach)
        })
      }
    },
    getOnlyMeCheckBoxValue: {
      get: function () {
        return this.onlyMeCheckBox
      },
      set: function (newValue) {
        this.onlyMeCheckBox = newValue
        if (newValue) {
          this.onlyMeCheckBox = 'onlyme'
          this.supportCheckBox = false
        }
      }
    },
    getSupportCheckBoxValue: {
      get: function () {
        return this.supportCheckBox
      },
      set: function (newValue) {
        this.supportCheckBox = newValue
        if (newValue) {
          this.supportCheckBox = 'support'
          this.onlyMeCheckBox = false
        }
      }
    }
  },
  watch: {
    selectedEnrolledUserIdArr: function (newValue, oldValue) {
      // AK: first calculate number of Enrolled participant with applied filter (if selected)
      var enrolledUserCount = 0
      for (var i = 0; i < this.getUserList.length; i++) {
        var isUnEnrolled = this.getUserList[i].Unenrolled
        var minValue = parseInt(this.selectedProgressBucketObj.MinValue)
        var maxValue = parseInt(this.selectedProgressBucketObj.MaxValue)
        var userProgress = parseInt(this.getUserList[i].UserProgress)
        if (!isUnEnrolled) {
          if (this.selectedProgressBucketObj !== '-1') {
            // console.log('userProgress >>> ' + userProgress)
            // console.log('minValue >>> ' + minValue)
            // console.log('maxValue >>> ' + maxValue)
            if ((userProgress >= minValue) && (maxValue >= userProgress)) {
              // console.log('If If >>> ' + JSON.stringify(this.getUserList[i]))
              enrolledUserCount += 1
            }
          } else {
            console.log('else')
            enrolledUserCount += 1
          }
        }
      }
      var selectedArrLen = parseInt(newValue.length)
      // console.log(enrolledUserCount + ' >>>> ' + selectedArrLen)
      // AK: Used to show Select All option selected or not
      if (enrolledUserCount === selectedArrLen && selectedArrLen > 0) {
        this.isSelectedAllEnrolledUser = true
      } else {
        this.isSelectedAllEnrolledUser = false
      }
      if (enrolledUserCount > 0) {
        this.showNoUserTxtInEnrolledUserBox = false
      } else {
        this.showNoUserTxtInEnrolledUserBox = true
      }
    },
    selectedUnEnrolledUserIdArr: function (newValue, oldValue) {
      // AK: first calculate number of Un-Enrolled participant with applied filter (if selected)
      var unEnrolledUserCount = 0
      for (var i = 0; i < this.getUserList.length; i++) {
        var isUnEnrolled = this.getUserList[i].Unenrolled
        var minValue = parseInt(this.selectedProgressBucketObj.MinValue)
        var maxValue = parseInt(this.selectedProgressBucketObj.MaxValue)
        var userProgress = parseInt(this.getUserList[i].UserProgress)
        if (isUnEnrolled) {
          if (this.selectedProgressBucketObj !== '-1') {
            // console.log('userProgress >>> ' + userProgress)
            // console.log('minValue >>> ' + minValue)
            // console.log('maxValue >>> ' + maxValue)
            if ((userProgress >= minValue) && (maxValue >= userProgress)) {
              // console.log('If If >>> ' + JSON.stringify(this.getUserList[i]))
              unEnrolledUserCount += 1
            }
          } else {
            console.log('else')
            unEnrolledUserCount += 1
          }
        }
      }
      var selectedArrLen = parseInt(newValue.length)
      // console.log(unEnrolledUserCount + ' >>>> ' + selectedArrLen)
      // AK: Used to show Select All option selected or not
      if (unEnrolledUserCount === selectedArrLen && selectedArrLen > 0) {
        this.isSelectedAllUnEnrolledUser = true
      } else {
        this.isSelectedAllUnEnrolledUser = false
      }
      if (unEnrolledUserCount > 0) {
        this.showNoUserTxtInUnEnrolledUserBox = false
      } else {
        this.showNoUserTxtInUnEnrolledUserBox = true
      }
    },
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      this.selectedCohortObj = -1
      this.isSelectedAllUnEnrolledUser = false
      this.isSelectedAllEnrolledUser = false
      this.showNoUserTxtInEnrolledUserBox = true
      this.showNoUserTxtInUnEnrolledUserBox = true
      this.selectedProgressBucketObj = '-1'
      this.progressBucketList = []
      this.selectedEnrolledUserIdArr = []
      this.selectedUnEnrolledUserIdArr = []
      // this.checkedEnrolledUserId = []
      // this.checkedUnEnrolledUserId = []
      this.getAssociatedCohortList()
      this.progressBucketList = []
      this.getProgressBucketFromServer()
    },
    selectedCohortObj: function () {
      // AK: Reset user object list
      this.UserObjList = []
      this.totalEnrolledUserCount = 0
      this.totalUnEnrolledUserCount = 0
      this.updateFlagState()
      this.getParticipantListUsingCohort()
    },
    /* selectedTemplateObj: function () {
      if (this.selectedTemplateObj.EmailTemplateText !== undefined) {
        this.templateContentValue = this.selectedTemplateObj.EmailTemplateText
      } else {
        this.templateContentValue = ''
      }
    }, */
    checkedEnrolledUserId: function (newValue, oldValue) {
      if (this.checkedEnrolledUserId.length === this.totalEnrolledUserCount) {
        this.isSelectedAllEnrolledUser = true
      } else {
        this.isSelectedAllEnrolledUser = false
      }
    },
    checkedUnEnrolledUserId: function (newValue, oldValue) {
      if (this.checkedUnEnrolledUserId.length === this.totalUnEnrolledUserCount) {
        this.isSelectedAllUnEnrolledUser = true
      } else {
        this.isSelectedAllUnEnrolledUser = false
      }
    }
  },
  name: 'viewProgressionEmailComponent'
}
</script>

<style scoped>
.opacity {
  opacity: 0.75;
}
.viewProgressionEmailComponent {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-88Perc {
  width: 88%;
}
.width-90Perc {
  width: 90%;
}
.width-96Perc {
  width: 96%;
}
.text-align-left {
  text-align: left !important;
}
.text-align-right {
  text-align: right !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.Padding-right-0px {
  padding-right: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.margin-bottom-1Perc {
  margin-bottom: 2% !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-top-1perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-size-15px {
  font-size: 15px;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.padding-bottom-2Perc{
  padding-bottom:2% !important;
}
.padding-bottom-5Perc{
  padding-bottom:5% !important;
}
.margin-bottom-10Perc{
  margin-bottom: 10% !important;
}
.padding-15px{
  padding:15px;
}
.border-1px{
  border: 1px solid #ccc;
}
.cursor-pointer{
    cursor: pointer;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.margin-top-0Point5Perc{
  margin-top: 0.5%;
}
.margin-top-1Perc{
  margin-top: 1%;
}
.margin-top-10px{
  margin-top: 10px;
}
.padding-right-0Perc{
  padding-right:0%;
}
.vertical-align {
  display: flex !important;
  align-items: center !important;
}
.align-center{
  align: center !important;
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.text-align-left{
  text-align: left !important;
}
.red-border{
  border: 1px solid red;
}
.vertical-align {
  display: flex !important; 
  align-items: center !important;
}
.font-size-14Px{
  font-size: 14px !important;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red {
  border: 1px solid red;
}
.padding-top-0Point5Perc {
  padding-top: 0.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/emails/progression_emails/ViewProgressionEmail.vue